import _0x461ac6 from'../utils/userAgent.js';export default function isLayoutViewport(){return!/^((?!chrome|android).)*safari/i['test'](_0x461ac6());}